import {
  ScanSearch,
  Video,
  FileText,
  TrendingUp,
  BarChart3,
  BriefcaseBusiness,
} from "lucide-react";
import { Reveal } from "./Reveal";

const features = [
  {
    icon: ScanSearch,
    name: "Thumbnail Analyzer",
    desc: "Score your thumbnails before you publish — clarity, contrast and click-appeal, analysed in seconds.",
    world: "CREATE",
    accent: "text-oriva-gold",
    tile: "bg-amber-50",
  },
  {
    icon: Video,
    name: "Video Analysis",
    desc: "Break down pacing, hooks and structure to understand why a video works — and how to improve yours.",
    world: "CREATE",
    accent: "text-oriva-gold",
    tile: "bg-amber-50",
  },
  {
    icon: FileText,
    name: "Document Generator",
    desc: "Draft polished documents, letters and reports from a short brief, ready to export and share.",
    world: "WORK",
    accent: "text-oriva-coral",
    tile: "bg-rose-50",
  },
  {
    icon: TrendingUp,
    name: "SEO Optimizer",
    desc: "Titles, descriptions and keywords tuned for search and discovery across platforms.",
    world: "WORK",
    accent: "text-oriva-coral",
    tile: "bg-rose-50",
  },
  {
    icon: BarChart3,
    name: "Data Analysis",
    desc: "Turn raw numbers and tables into clear summaries, trends and decision-ready insight.",
    world: "WORK",
    accent: "text-oriva-coral",
    tile: "bg-rose-50",
  },
  {
    icon: BriefcaseBusiness,
    name: "Business Planning",
    desc: "Shape rough ideas into structured plans, projections and roadmaps you can act on.",
    world: "WORK",
    accent: "text-oriva-coral",
    tile: "bg-rose-50",
  },
];

export const Flagship = () => (
  <section id="features" className="border-y border-slate-200 bg-slate-50 py-24 sm:py-32" data-testid="flagship-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">AI Tools</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
          Serious tools, not party tricks.
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600">
          Six flagship capabilities that show what ORIVA can really do.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((feature, i) => (
          <Reveal key={feature.name} delay={i * 0.06}>
            <article
              className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 transition-colors duration-200 hover:border-slate-300"
              data-testid={`flagship-card-${i}`}
            >
              <div className={`grid h-11 w-11 place-items-center rounded-xl ${feature.tile}`}>
                <feature.icon className={`h-5 w-5 ${feature.accent}`} />
              </div>
              <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-slate-900">
                {feature.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{feature.desc}</p>
              <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
                ORIVA {feature.world}
              </p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-10 font-mono text-xs uppercase tracking-[0.2em] text-slate-500" data-testid="flagship-disclaimer">
          Feature availability and limits vary by plan — see the ORIVA app for current details.
        </p>
      </Reveal>
    </div>
  </section>
);
